import service from '@/store/services/workshop/service_estimate-service';

const state = {
  list: {},
  service_estimate: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, service_estimate) => {
    state.service_estimate = service_estimate;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },
  
  list_ada_pkb({commit, dispatch}, params) {
    return service.list_ada_pkb(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  list_service({commit, dispatch}, params) {
    return service.list_service(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  list_part({commit, dispatch}, params) {
    return service.list_part(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  update_status({commit, dispatch}, params) {
    return service.update_status(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((service_estimate) => { commit('SET_RESOURCE', service_estimate); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  service_estimate: state => state.service_estimate,
  page: state => state.meta.page,
};
 
const service_estimate = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default service_estimate;
